






































import {Component, Prop} from 'vue-property-decorator'
import LastPriceUpdated from '../LastPriceUpdated.vue'
import PoweredBy, {PoweredByItem} from '../PoweredBy.vue'
import NftCollectionTable from '../nfts/NftCollectionTable.vue'
import {MixinScreenSize} from '../mixins/MixinScreenSize'
import {NftCollectionCollection} from '@/model/collection/NftCollectionCollection'

@Component({
  components: {
    LastPriceUpdated,
    PoweredBy,
    NftCollectionTable,
  },
})
export default class DappDetailedNftsContent extends MixinScreenSize {
  @Prop({type: NftCollectionCollection, required: true})
  nftCollectionCollection!: NftCollectionCollection

  poweredByList = [
    {
      url: 'https://ghostmarket.io/',
      alt: 'ghostmarket icon',
      filename: 'ghostmarket-icon.svg',
    } as PoweredByItem,
  ]
}
